import { useDispatch, useSelector } from "react-redux";
import { FaMoon } from "react-icons/fa";
import cx from "classnames";
import { RootState } from "store";
import { setTheme } from "store/tableSlice/index.slice";
import { Switch } from "components/atoms/Switch";

// Single source of truth for the dark-mode control — rendered in the user
// dropdown and at the end of the settings menu.
export const ThemeToggle = ({ className }: { className?: string }) => {
  const dispatch = useDispatch();

  const { theme } = useSelector((state: RootState) => {
    return state.tableSlice;
  });

  const isDark = theme === "dark";
  const toggle = () => dispatch(setTheme(isDark ? "light" : "dark"));

  return (
    <div
      className={cx(
        "flex items-center w-full gap-3 cursor-pointer select-none",
        className
      )}
      onClick={toggle}
    >
      <FaMoon className="flex-shrink-0 text-gray9" />
      <span className="mr-auto">Dark mode</span>
      {/* pointer-events-none so row clicks don't double-toggle; the switch
          stays keyboard-focusable (Radix role="switch"). */}
      <Switch
        checked={isDark}
        onCheckedChange={toggle}
        className="pointer-events-none flex-shrink-0"
      />
    </div>
  );
};
